// extracted by mini-css-extract-plugin
module.exports = {"iframe":"_a7a1f76","paper":"_2dc20e2","content":"_80a1483"};